import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Overview18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_647)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.4 5.25C9.76487 5.25 9.25 5.76487 9.25 6.4V9.6C9.25 10.2351 9.76487 10.75 10.4 10.75H13.6C14.2351 10.75 14.75 10.2351 14.75 9.6V6.4C14.75 5.76487 14.2351 5.25 13.6 5.25H10.4ZM10.75 6.75H13.25V9.25H10.75V6.75Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 8C2.25 3.71979 5.71979 0.25 10 0.25C14.2802 0.25 17.75 3.71979 17.75 8C17.75 12.2802 14.2802 15.75 10 15.75C8.13002 15.75 6.41472 15.0877 5.07588 13.9849L1.53038 17.5303L0.469727 16.4697L4.01521 12.9242C2.91233 11.5854 2.25 9.87004 2.25 8ZM10 1.75C7.535 1.75 5.4033 3.17702 4.38595 5.25H6.60002C7.22639 5.25 7.75002 5.77363 7.75002 6.4V9.6C7.75002 10.2264 7.22641 10.75 6.60002 10.75H4.38595C5.4033 12.823 7.535 14.25 10 14.25C13.4518 14.25 16.25 11.4518 16.25 8C16.25 4.54822 13.4518 1.75 10 1.75ZM3.87502 6.75H6.25002V9.25H3.87502C3.71105 8.44222 3.71105 7.55777 3.87502 6.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_647'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Overview18.displayName = 'Overview18';
export default Overview18;
